import React from "react";

const Galerie = () => {
  return (
    <div>
      <h1>Galerie</h1>
      <p>nevimmm</p>
    </div>
  );
};

export default Galerie;